import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonThemeLegacy, IconDirection, IconName } from 'studio-components';
import { Dropdown, IconPosition, Option, OptionValue } from '../../types';
import { GetPipe } from '../../pipes/get.pipe';

@Component({
  selector: 'studio-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
})
export class DropdownSelectComponent implements OnChanges, Dropdown {
  /* DropDown inputs */
  @Input() public options: Option[] = [];
  @Input() public displayLabel = 'value';
  @Input() public displayKey = 'id';
  @Input() public displayDescription = '';
  @Input() public placeHolder = '';
  @Input() public selected: OptionValue;
  @Output() public selectionChange = new EventEmitter<OptionValue>();

  /* Icon inputs */
  @Input() public iconName: IconName;
  @Input() public iconDirection: IconDirection;
  @Input() public iconPosition: IconPosition = 'left';
  @Input() public iconSize = 20;

  /* Button inputs */
  @Input() public buttonTheme: ButtonThemeLegacy = 'white';

  public isOpen = false;
  public selectedOption = null;

  constructor(public getPipe: GetPipe) {}

  public optionSelect(option): void {
    const selectedOption = this.getPipe.transform(option, this.displayKey);

    this.selectedOption = option;
    this.selectionChange.emit(selectedOption);
  }

  public menuOpened(): void {
    this.isOpen = true;
  }

  public menuClosed(): void {
    this.isOpen = false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { selected, options } = changes;

    if (selected || options) {
      this.selectedOption = this.options.find(
        (option) => this.getPipe.transform(option, this.displayKey) === this.selected,
      );
    }
  }
}
